import { DataActions } from './constants';
import { orderBy, get } from 'lodash';
import {Order} from "./dataProvider";

export const dataInit = (dataId, defaultProps) => ({
  type: DataActions.INIT,
  dataId,
  defaultProps,
});

export const dataLoad = dataId =>
  (dispatch, getState) => {
    const state = getState().grid[dataId];
    const { items, sort, order, page, pageSize } = state;

    state.allItems = state.allItems || items;

  const sorted = orderBy(
      state.allItems,
      [item => {
        const val = get(item, sort);
        return typeof val === 'string'
            ? val.toLocaleLowerCase('cs')
            : val;
      }],
      [order === Order.ASC ? 'asc' : 'desc']
  );

    const start = (page) * pageSize;
    const paged = sorted.slice(start, start + pageSize);

    dispatch({
      type: DataActions.LOAD,
      dataId,
      items: paged,
      count: state.allItems.length,
    });
  };

export const dataFilterRemove = (dataId, filter) =>
  dispatch => {
    dispatch({
      type: DataActions.FILTER_REMOVE,
      dataId,
      filter,
    });

    dispatch(dataLoad(dataId));
  };

export const setItems = (dataId, payload) => ({
  type: DataActions.SET_ITEMS,
  dataId,
  payload,
});

export const dataFilterEdit = (dataId, filter, newFilter) =>
  dispatch => {
    dispatch({
      type: DataActions.FILTER_EDIT,
      dataId,
      filter,
      newFilter,
    });

    dispatch(dataLoad(dataId));
  };

export const dataFilterAdd = dataId =>
  dispatch => {
    dispatch({
      type: DataActions.FILTER_ADD,
      dataId,
    });

    dispatch(dataLoad(dataId));
  };

export const dataPageSize = (dataId, pageSize) =>
  dispatch => {
    dispatch({
      type: DataActions.PAGE_SIZE,
      dataId,
      pageSize,
    });

    dispatch(dataLoad(dataId));
  };

export const dataPage = (dataId, page) =>
  dispatch => {
    dispatch({
      type: DataActions.PAGE,
      dataId,
      page,
    });

    dispatch(dataLoad(dataId));
  };

export const dataSort = (dataId, sort) =>
  dispatch => {
    dispatch({
      type: DataActions.SORT,
      dataId,
      sort,
    });

    dispatch(dataLoad(dataId));
  };

export const dataOrder = (dataId, order) =>
  dispatch => {
    dispatch({
      type: DataActions.ORDER,
      dataId,
      order,
    });

    dispatch(dataLoad(dataId));
  };

export const dataFilterOpen = (dataId, isOpen) => ({
  type: DataActions.FILTER_OPEN,
  dataId,
  isOpen,
});
